let landingAPISetting: null | boolean = null;

export const setShowPriceInButton = (value: boolean) => {
  landingAPISetting = value;
};

export const showPriceInButton = () => !!landingAPISetting;
